<template>
  <div id="HomePage">
    <hero-banner />
    <our-story-section />
    <promotion-section />
    <section class="section" style="background-color: #0a0a0a;">
      <div class="container">
        <h1 class="title" style="color: white;">FOOD & DRINKS</h1>
        <div class="section" style="padding-top: 0;">
          <div class="columns is-multiline">
            <div class="column is-4-desktop is-6-tablet is-12-mobile">
              <img src="@/assets/menu/menu-2.jpg" />
            </div>
            <div class="column is-4-desktop is-6-tablet is-12-mobile">
              <img src="@/assets/menu/menu-3.jpg" />
            </div>
            <div class="column is-4-desktop is-6-tablet is-12-mobile">
              <img src="@/assets/menu/menu-4.jpg" />
            </div>
            <div class="column is-4-desktop is-6-tablet is-12-mobile">
              <img src="@/assets/menu/menu-5.jpg" />
            </div>
            <div class="column is-4-desktop is-6-tablet is-12-mobile">
              <img src="@/assets/menu/menu-16.jpg" />
            </div>
            <div class="column is-4-desktop is-6-tablet is-12-mobile">
              <img src="@/assets/menu/menu-17.jpg" />
            </div>
            <div class="column is-4-desktop is-6-tablet is-12-mobile">
              <img src="@/assets/menu/menu-18.jpg" />
            </div>
            <div class="column is-4-desktop is-6-tablet is-12-mobile">
              <img src="@/assets/menu/menu-19.jpg" />
            </div>
            <div class="column is-4-desktop is-6-tablet is-12-mobile">
              <img src="@/assets/menu/menu-20.jpg" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src

import HeroBanner from "@/components/HeroBanner";
import OurStorySection from "@/components/OurStorySection";
import PromotionSection from "@/components/PromotionSection";

export default {
  name: "HomePage",
  components: {
    HeroBanner,
    OurStorySection,
    PromotionSection
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
